import Util from '../lib/util.js';
const isArray = Array.isArray;
const isEmpty = Util.isEmpty;

const KpiFns = {
  /**
   * 生成线性渐变颜色 for Echarts
   *
   * @param arrColor: 起止颜色
   * @param direction: 方向 1.垂直 2.水平
   */
  linearGradient(arrColor: string[] = [], direction: number = 1) {
    let color0 = arrColor[0] || 'rgb(255, 255, 255)';
    let color1 = arrColor[1] || 'rgb(0, 0, 0)';
    return {
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        {
          offset: 0,
          color: color0 // 0% 处的颜色
        },
        {
          offset: 1,
          color: color1 // 100% 处的颜色
        }
      ],
      globalCoord: false // 缺省为 false
    };
  },

  //格式化绩效月份显示
  formatMonth(v) {
    return v.substr(0, 4) + '-' + v.substr(4, 2);
  },

  //生成趋势线图配置
  genLineOpt(data, opt?) {
    let xAxisData: string[] = [];
    let seriesData: number[] = [];
    let length: number = 0;
    let start: number = 0;

    data.forEach(item => {
      xAxisData.push(this.formatMonth(item.assessmentMonth));
      seriesData.push(item.score);
    });

    length = xAxisData.length;
    if (length > 12) {
      //数据超过12个月时，dataZoom生效
      start = Math.floor(((length - 12) / length) * 100);
    }

    return Object.assign(
      {
        type: 'line',
        color: ['rgb(71, 189, 237)'],
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          data: xAxisData
        },
        grid: {
          left: 60,
          right: 60,
          top: 60,
          bottom: 60
        },
        dataZoom: [
          {
            start
          }
        ],
        series: [
          {
            data: seriesData
          }
        ]
      },
      opt
    );
  },

  //生成价格变动线图配置
  genPirceLineOpt(data, opt?) {
    let xAxisData: string[] = [];
    let seriesData: number[] = [];
    let length: number = 0;
    let start: number = 0;

    data.forEach(item => {
      xAxisData.push(Util.dateFormat(item.marketDate, 'yyyy-MM-dd'));
      seriesData.push(item.price);
    });

    length = xAxisData.length;
    if (length > 12) {
      //数据超过12个月时，dataZoom生效
      start = Math.floor(((length - 12) / length) * 100);
    }

    return Object.assign(
      {
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: [
          {
            start
          }
        ],
        series: [
          {
            data: seriesData,
            type: 'line'
          }
        ]
      },
      opt
    );
  },

  //渲染单月指标雷达图
  genRadarOpt(data) {
    if (isEmpty(data)) {
      return {
        type: 'radar',
        radar: {},
        series: [
          {
            data: []
          }
        ]
      };
    }
    let indicator: any[] = [];
    let seriesData: number[] = [];

    data.forEach(item => {
      indicator.push({ name: item.standardItemName, max: 100 });
      seriesData.push(item.score);
    });

    return {
      type: 'radar',
      radar: {
        indicator
      },
      series: [
        {
          name: '供应体系综合能力',
          data: [{ value: seriesData }]
        }
      ]
    };
  },

  //比价供应商绩效等级雷达图
  genCompareRadarOpt(data, color: string = '#fff') {
    let indicator: any[] = [];
    let seriesData: number[] = [];

    data.forEach(item => {
      indicator.push({
        name: item.standardItemName + '\n' + item.score + '%',
        max: 100,
        color: color
      });
      seriesData.push(item.score);
    });

    return {
      type: 'radar',
      tooltip: {
        position: 'top'
      },
      radar: {
        radius: '55%',
        name: {
          rich: {
            a: {
              color: '#20a8d8',
              lineHeight: 18,
              align: 'center'
            }
          },
          formatter: (a, b) => {
            return `{a|${a}}`;
          }
        },
        indicator: indicator
      },
      series: [
        {
          name: '绩效等级',
          type: 'radar',
          itemStyle: { normal: { areaStyle: { type: 'default' } } },
          data: [{ value: seriesData }]
        }
      ]
    };
  },

  //供应商平台评价雷达图
  genCompareRadarOpt2(data, color: string = '#fff') {
    let ret: any = this.genCompareRadarOpt(data, color);
    ret.series[0].name = '平台评价';
    ret.series[0].itemStyle = { color: 'rgb(251,165,26)' };
    return ret;
  },

  //绩效标准玫瑰图
  genRosePieOpt(data) {
    let opt = {
      tooltip: {
        trigger: 'item',
        formatter: param => {
          return param.value + '%';
        }
      },
      series: [
        {
          name: '绩效标准',
          type: 'pie',
          radius: '85%',
          center: ['50%', '50%'],
          data: data.sort(function (a, b) {
            return a.value - b.value;
          }),
          roseType: 'area',
          label: {
            textStyle: {
              color: '#333'
            }
          },
          labelLine: {
            lineStyle: {
              color: '#333'
            },
            smooth: 0.2,
            length: 10,
            length2: 20
          },
          itemStyle: {
            normal: {
              shadowBlur: 2,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          animationType: 'scale',
          animationEasing: 'elasticOut',
          animationDelay: function (idx) {
            return Math.random() * 200;
          }
        }
      ]
    };
    return opt;
  },

  /**
   * 过滤权重为零的指标（当 weightViewFlag === 1 && standardType === 0 时）
   * 利润中心和供应商分类过滤后会导致无法对齐，所以不支持隐藏零权重指标
   *
   * @param list
   * @returns
   */
  parseWeightViewFlag(list) {
    if (list.length > 0) {
      let { weightViewFlag, standardType } = list[0];
      if (weightViewFlag === 1 && standardType === 0) {
        list.forEach(row => {
          row.detailList = row.detailList.filter(
            item => ![undefined, null, 0].includes(item.weight)
          );
        });
      }
    }
  }
};

export default KpiFns;
